/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 *
 * ======================================================================== */

// window.$ = window.jQuery = require('jquery');

// Define Methods/Functions outside the router for reusability

var Broadcaster = require('./modules/broadcaster.js'),
	Scroller = require('./modules/scroller.js'),
	MobileNav = require('./modules/mobileNav.js'),
	Debounce = require('./modules/debounce.js'),
	Tabs = require('./modules/tabs.js'),
	Collapser = require('./modules/collapser.js'),
	StickyHeader = require('./modules/stickyHeader.js'),
	ImagesLoaded = require('./modules/imagesLoaded.js'),
	ParallaxHero = require('./modules/parallaxHero.js');

/*
 * Babel assigns default exports to the default property.
 * So if you use require to import ES6 modules, you need to access the default property
 */
var AOS = require('aos/dist/aos.js');
var PhotoSwipe = require('photoswipe');
var PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
var Swiper = require('swiper/dist/js/swiper.js');

/*
 * Use this variable to set up the common and page specific functions. If you
 * rename this variable, you will also need to rename the namespace below.
 */

var Router = {
	// All pages
	common: {

		init: function () {

            /*
			 * Javascript to be fired on every page
             * These can be deleted or refactored to the page where it is used
			 */

			// Initialize common modules

			const feather = require('feather-icons')
			feather.replace()

			ImagesLoaded.init('.js-loaded');
			MobileNav.init('.js-menu__toggle');

			Tabs.init('.js-tabs');
			Collapser.init('.js-collapser-toggle');


			var slider = new Swiper('.js-slider', {
				autoHeight: true,
				parallax:true,
				navigation: {
					nextEl: '.js-slider-next',
					prevEl: '.js-slider-prev',
				},
				pagination: {
					el: '.js-slider-pagination',
				},
				speed: 750
			});

			var galleryThumbs = new Swiper('.js-gallery-thumbs', {
				spaceBetween: 15,
				slidesPerView: 6,
				freeMode: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			  });
			  
			  var galleryTop = new Swiper('.js-gallery', {
				autoHeight: true,
				spaceBetween: 20,
				effect: 'fade',
				navigation: {
					nextEl: '.js-slider-next',
					prevEl: '.js-slider-prev',
				},
				thumbs: {
				  swiper: galleryThumbs
				}
			  });

			AOS.init({
				startEvent: 'load',
			});

		},

		// Finalize will get fired after all js in common.init and page specific js
		finalize: function () {
			Scroller.init();
		}
	},
	home: {
		init: function () {
			StickyHeader.init();
			ParallaxHero.init();
		}
	},

	single: {
		init: function () {
			var slider = new Swiper('.js-post-gallery', {
				navigation: {
					nextEl: '.js-slider-next',
					prevEl: '.js-slider-prev',
				},
				spaceBetween: 15,
				slidesPerView: 3,
				speed: 750
			});

			var initPhotoSwipeFromDOM = function(gallerySelector) {
				// parse slide data (url, title, size ...) from DOM elements
				// (children of gallerySelector)
				var parseThumbnailElements = function(el) {
				  var thumbElements = el.childNodes,
					numNodes = thumbElements.length,
					items = [],
					figureEl,
					linkEl,
					size,
					item;
			  
				  for (var i = 0; i < numNodes; i++) {
					figureEl = thumbElements[i]; // <figure> element
			  
					// include only element nodes
					if (figureEl.nodeType !== 1) {
					  continue;
					}
			  
					linkEl = figureEl.children[0]; // <a> element
			  
					size = linkEl.getAttribute("data-size").split("x");
			  
					// create slide object
					item = {
					  src: linkEl.getAttribute("href"),
					  w: parseInt(size[0], 10),
					  h: parseInt(size[1], 10)
					};
			  
					if (figureEl.children.length > 1) {
					  // <figcaption> content
					  item.title = figureEl.children[1].innerHTML;
					}
			  
					if (linkEl.children.length > 0) {
					  // <img> thumbnail element, retrieving thumbnail url
					  item.msrc = linkEl.children[0].getAttribute("src");
					}
			  
					item.el = figureEl; // save link to element for getThumbBoundsFn
					items.push(item);
				  }
			  
				  return items;
				};
			  
				// find nearest parent element
				var closest = function closest(el, fn) {
				  return el && (fn(el) ? el : closest(el.parentNode, fn));
				};
			  
				// triggers when user clicks on thumbnail
				var onThumbnailsClick = function(e) {
				  e = e || window.event;
				  e.preventDefault ? e.preventDefault() : (e.returnValue = false);
			  
				  var eTarget = e.target || e.srcElement;
			  
				  // find root element of slide
				  var clickedListItem = closest(eTarget, function(el) {
					return el.tagName && el.tagName.toUpperCase() === "LI";
				  });
			  
				  if (!clickedListItem) {
					return;
				  }
			  
				  // find index of clicked item by looping through all child nodes
				  // alternatively, you may define index via data- attribute
				  var clickedGallery = clickedListItem.parentNode,
					childNodes = clickedListItem.parentNode.childNodes,
					numChildNodes = childNodes.length,
					nodeIndex = 0,
					index;
			  
				  for (var i = 0; i < numChildNodes; i++) {
					if (childNodes[i].nodeType !== 1) {
					  continue;
					}
			  
					if (childNodes[i] === clickedListItem) {
					  index = nodeIndex;
					  break;
					}
					nodeIndex++;
				  }
			  
				  if (index >= 0) {
					// open PhotoSwipe if valid index found
					openPhotoSwipe(index, clickedGallery);
				  }
				  return false;
				};
			  
				// parse picture index and gallery index from URL (#&pid=1&gid=2)
				var photoswipeParseHash = function() {
				  var hash = window.location.hash.substring(1),
					params = {};
			  
				  if (hash.length < 5) {
					return params;
				  }
			  
				  var vars = hash.split("&");
				  for (var i = 0; i < vars.length; i++) {
					if (!vars[i]) {
					  continue;
					}
					var pair = vars[i].split("=");
					if (pair.length < 2) {
					  continue;
					}
					params[pair[0]] = pair[1];
				  }
			  
				  if (params.gid) {
					params.gid = parseInt(params.gid, 10);
				  }
			  
				  return params;
				};
			  
				var openPhotoSwipe = function(
				  index,
				  galleryElement,
				  disableAnimation,
				  fromURL
				) {
				  var pswpElement = document.querySelectorAll(".pswp")[0],
					gallery,
					options,
					items;
			  
				  items = parseThumbnailElements(galleryElement);
			  
				  // define options (if needed)
			  
				  options = {
					/* "showHideOpacity" uncomment this If dimensions of your small thumbnail don't match dimensions of large image */
					//showHideOpacity:true,
			  
					// Buttons/elements
					closeEl: true,
					captionEl: true,
					fullscreenEl: true,
					zoomEl: true,
					shareEl: true,
					counterEl: false,
					arrowEl: true,
					preloaderEl: true,
					// define gallery index (for URL)
					galleryUID: galleryElement.getAttribute("data-pswp-uid"),
					getThumbBoundsFn: function(index) {
					  // See Options -> getThumbBoundsFn section of documentation for more info
					  var thumbnail = items[index].el.getElementsByTagName("img")[0], // find thumbnail
						pageYScroll =
						  window.pageYOffset || document.documentElement.scrollTop,
						rect = thumbnail.getBoundingClientRect();
			  
					  return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
					}
				  };
			  
				  // PhotoSwipe opened from URL
				  if (fromURL) {
					if (options.galleryPIDs) {
					  // parse real index when custom PIDs are used
					  // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
					  for (var j = 0; j < items.length; j++) {
						if (items[j].pid == index) {
						  options.index = j;
						  break;
						}
					  }
					} else {
					  // in URL indexes start from 1
					  options.index = parseInt(index, 10) - 1;
					}
				  } else {
					options.index = parseInt(index, 10);
				  }
			  
				  // exit if index not found
				  if (isNaN(options.index)) {
					return;
				  }
			  
				  if (disableAnimation) {
					options.showAnimationDuration = 0;
				  }
			  
				  // Pass data to PhotoSwipe and initialize it
				  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
				  gallery.init();
			  
				  /* EXTRA CODE (NOT FROM THE CORE) - UPDATE SWIPER POSITION TO THE CURRENT ZOOM_IN IMAGE (BETTER UI) */
			  
				  // photoswipe event: Gallery unbinds events
				  // (triggers before closing animation)
				  gallery.listen("unbindEvents", function() {
					// This is index of current photoswipe slide
					var getCurrentIndex = gallery.getCurrentIndex();
					// Update position of the slider
					slider.slideTo(getCurrentIndex, false);
				  });
				};
			  
				// loop through all gallery elements and bind events
				var galleryElements = document.querySelectorAll(gallerySelector);
			  
				for (var i = 0, l = galleryElements.length; i < l; i++) {
				  galleryElements[i].setAttribute("data-pswp-uid", i + 1);
				  galleryElements[i].onclick = onThumbnailsClick;
				}
			  
				// Parse URL and open gallery if it contains #&pid=3&gid=1
				var hashData = photoswipeParseHash();
				if (hashData.pid && hashData.gid) {
				  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
				}
			  };
			  
			  // execute above function
			  initPhotoSwipeFromDOM(".js-photoswipe-gallery");
		}
	},

	template_contact: {
		init: function () {
			
		}
	},

	woocommerce_page: {
		init:function () {
			$('select').each(function(){
				$(this).wrap( "<div class='select-wrap form__control'></div>" );
				$(this).parent().append('<i class="fas fa-chevron-down"></i>');
			});
		}
	},

	error404: {
		init: function () {

		}
	}
};

module.exports = Router;

/*
 * The routing fires all common scripts, followed by the page specific scripts.
 * Add additional events for more control over timing e.g. a finalize event
*/
var UTIL = {

	fire: function (func, funcname, args) {
		var namespace = Router;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
			namespace[func][funcname](args);
		}
	},
	loadEvents: function () {
		UTIL.fire('common');

		$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
			UTIL.fire(classnm);
		});

		UTIL.fire('common', 'finalize');
	}

};

$(document).ready(UTIL.loadEvents);



// WEBPACK FOOTER //
// ./assets/src/js/scripts.js